/*
 * rheincool — Öffnungszeiten, gemeinsam genutzt
 *
 * Ein Fahrplan, zwei Verbraucher: der Verfügbarkeitsindikator im Header und
 * die Erwartungszeile am WhatsApp-Button. Zwei Kopien derselben Logik würden
 * irgendwann auseinanderlaufen — und dann sagt der Header „erreichbar",
 * während daneben „wir antworten morgen" steht.
 *
 * Format: "1-5:9-16" (Mo–Fr 9–16 Uhr), mehrere Regeln per Komma.
 * Tage nach ISO: 1 = Montag … 7 = Sonntag.
 */
(() => {
  'use strict';

  function fahrplan(text) {
    const map = {};
    (text || '').split(',').forEach((teil) => {
      const m = teil.trim().match(/^(\d)(?:-(\d))?:(\d{1,2})-(\d{1,2})$/);
      if (!m) return;
      const bis = m[2] ? parseInt(m[2], 10) : parseInt(m[1], 10);
      for (let d = parseInt(m[1], 10); d <= bis; d += 1) {
        map[d] = [parseInt(m[3], 10), parseInt(m[4], 10)];
      }
    });
    return Object.keys(map).length ? map : null;
  }

  function jetzt(datum) {
    const d = datum || new Date();
    return { tag: d.getDay() === 0 ? 7 : d.getDay(), stunde: d.getHours() + d.getMinutes() / 60 };
  }

  function istOffen(map, datum) {
    if (!map) return false;
    const { tag, stunde } = jetzt(datum);
    const fenster = map[tag];
    return Boolean(fenster && stunde >= fenster[0] && stunde < fenster[1]);
  }

  window.rcOeffnung = { fahrplan, istOffen, jetzt };
})();
